let show_text_attr = 'data-show-text';

class sheetDisplay {

    constructor() {
        this.container = $('.row.locations.vendor-rate-block');
        this.open = false;
        this.openContainer = undefined;

        $(window).on('resize', () => {
            this.onResize()
        });

        $('.show-locations', this.container).on('click', (event) => {
            //get all vendor location containers (vlc) within the parent container
            let vlcs = this.container.find('.vlc');
            //and hide all of them
            vlcs.hide();


            // get the clicked element's jQuery object
            let clickedElement = $(event.target);
            let clickedIsOpen = event.target.hasAttribute(show_text_attr);

            //get all "A" tags which have "data-show-text" attribute set
            this.container.find('a.show-locations[' + show_text_attr + ']').each((i, elem) => {
                elem = $(elem);
                // put the text back
                elem.html(elem.attr(show_text_attr));
                // and remove the attribute
                elem.removeAttr(show_text_attr);
            });

            this.open = false;
            this.openContainer = undefined;

            if (!clickedIsOpen) {
                this.open = true;
                this.doOpen(clickedElement);
            }

            event.preventDefault();
            return false;
        })

        $('.toggle-info-btn', this.container).on('click', (event) => {
            this.doToggleDetails($(event.target));
        })

        $('.responsive-tabs li', this.container).on('click', (event) => {
            let vlc = $(event.target).parents('.vnd-locations').find('.vlc');
            this.adjustSizes(vlc);
        })
    }

    doToggleDetails(clickedElement) {
        let rate = clickedElement.parents('.vnd-locations').find('.vendor-rate-content');
        let vendorDetail = clickedElement.parents('.vnd-locations').find('.vendor-detail');
        clickedElement.parents('.rate-header').find('.toggle-info-btn').toggleClass('active');
        this.toggleElement(rate);
        this.toggleElement(vendorDetail);
    }

    toggleElement(element) {
        const duration = 100;
        const easing = 'swing';
        element.toggle({ duration, easing })
            .toggleClass('show');
    }

    doOpen(clickedElement) {
        // find it's parent vendor location container
        let vlc = clickedElement.parents('.vnd-locations').find('.vlc');

        this.container.find('.card-content .vendor-detail:visible').parents('.vnd-locations').map((index, elem) => {
            if ($(elem).attr('data-vendor-location-id') !== vlc.parents('.vnd-locations').attr('data-vendor-location-id')) {
                this.doToggleDetails($(elem).find('.vnd .toggle-info-btn'));
            }
        });

        // and show it
        vlc.show();

        this.adjustSizes(vlc);

        // put the current value of innerHTML into the data-show-text attribute, creating the attribute
        clickedElement.attr(show_text_attr, clickedElement.html());
        // put the value of "data-hide-text" attribute into the innerHTML
        clickedElement.html(clickedElement.attr('data-hide-text'));

        this.openContainer = vlc;
    }

    adjustSizes(vlc) {
        // find inner and it's height
        let inner = vlc.find('.inner');

        let inner_height = parseInt(inner.height());
        // and set height of the vlc to match the inner's height
        vlc.height(inner_height + 10); //height of the arrow

        // find background
        let vlc_background = vlc.find('.vlcBackground');
        // and set it's height too
        vlc_background.height(inner_height);
    }

    onResize() {
        if (this.open) {
            window.console.log('Resize open VLC');
            this.adjustSizes(this.openContainer);
        }
    }
}

new sheetDisplay();